import React from 'react';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';

import { IGoalsAndOperationalPlansFormValues } from './types';
import { zodResolver } from '@hookform/resolvers/zod';
import { GoalsAndOperationalPlansSchema } from './validators';

type GoalAndOperationalPlansContext =
  UseFormReturn<IGoalsAndOperationalPlansFormValues>;

type GoalAndOperationalPlansFormSubmission = (
  formUtils: GoalAndOperationalPlansContext
) => SubmitHandler<IGoalsAndOperationalPlansFormValues>;

type GoalAndOperationalPlansFormProviderType = {
  children: React.ReactNode;
  onSubmit?: GoalAndOperationalPlansFormSubmission;
  initialValues?: IGoalsAndOperationalPlansFormValues;
};

const useGoalAndOperationalPlansForm = () =>
  useFormContext<IGoalsAndOperationalPlansFormValues>();

const defaultFormValues: IGoalsAndOperationalPlansFormValues = {
  companyValueIncreasePlans: {
    valueUpPlans: [],
  },
  isAllCompletedTh: false,
  isAllCompletedEn: false,
};

const GoalAndOperationalPlansFormProvider = (
  props: GoalAndOperationalPlansFormProviderType
) => {
  const { children, initialValues, onSubmit } = props;

  const formContext = useForm<IGoalsAndOperationalPlansFormValues>({
    mode: 'onChange',
    defaultValues: initialValues ?? defaultFormValues,
    resolver: zodResolver(GoalsAndOperationalPlansSchema),
  });

  return (
    <FormProvider {...formContext}>
      <form
        onSubmit={
          typeof onSubmit === 'function'
            ? formContext.handleSubmit(onSubmit(formContext))
            : undefined
        }
        style={{ width: '100%' }}
        noValidate
      >
        {children}
      </form>
    </FormProvider>
  );
};

export { useGoalAndOperationalPlansForm };
export default GoalAndOperationalPlansFormProvider;
